import { createApp } from 'vue';
import modalRdv from '../_03_organisms/offer/modal-rdv-component.vue';
import UserSetting from './user-setting';
import { URL_USER_SETTINGS_ONBOARDING_MATCH_RDV } from '../_00_elements/tools/routes/routes';

/**
 * Init RDV Modal Vue
 */
export default function () {
  const component = {
    components: {
      modalRdv,
    },
    mixins: [ UserSetting ],
    data() {
      return {
        isRDVModalOpened: false,
      };
    },
    mounted() {
      this.showRDVModal();
    },
    methods: {
      showRDVModal: function showRDVModal() {
        this.isRDVModalOpened = true;
      },
      closeRDVModal: function closeRDVModal() {
        this.isRDVModalOpened = false;
        this.enableUserSetting(URL_USER_SETTINGS_ONBOARDING_MATCH_RDV);
      },
    },
  };

  return createApp(component).mount('.rdv');
}
